import { graphql } from "msw";

import {
  AddToCartMutation,
  AddToCartMutationVariables,
} from "../../../generated/graphql";
import { OFFER_ID_THAT_WILL_THROW_ERROR } from "../../constants/literals";

import {
  mockCart,
  mockCartMarketplaceParcelItems,
  mockCartOrderSummary,
  mockCartParcel,
  mockCartParcelItems,
  mockRecommendationParcelItem,
} from "./mockCart";

export const handler = graphql.mutation<
  AddToCartMutation,
  AddToCartMutationVariables
>("AddToCart", (req, res, ctx) => {
  const { offerId } = req.variables;
  const otherParcels = mockCartParcel.slice(1);

  if (offerId === OFFER_ID_THAT_WILL_THROW_ERROR) {
    return res(
      ctx.data({
        addToCart: {
          __typename: "UserError" as const,
          message: "Item is out of stock.",
        },
      })
    );
  }

  const modifiedCart = {
    ...mockCart,
    itemsQuantitySum: 5,
    parcels: [
      {
        ...mockCartParcel[0],
        items: [...mockCartParcelItems, mockRecommendationParcelItem],
      },
      ...otherParcels,
    ],
    orderSummary: {
      ...mockCartOrderSummary,
      itemSummary: {
        items: [
          ...mockCartParcelItems,
          mockRecommendationParcelItem,
          ...mockCartMarketplaceParcelItems,
        ],
        total: {
          amount: 20000,
          currency: "AUD",
        },
      },
      subtotalPrice: {
        __typename: "Money" as const,
        amount: 20000,
      },
      totalPrice: {
        __typename: "Money" as const,
        amount: 18500,
      },
    },
  };

  return res(
    ctx.data({
      addToCart: modifiedCart,
    })
  );
});
